export default __webpack_public_path__ + "/assets/progetto_10.jpg";